// NOTICE: KAPTION-INTEGRATION
// team-location.UI.1 — the team location map. Open to every role at the router;
// the page itself (and the API behind it) enforce `team_location_view`.
import { frontendURL } from '../../../helper/URLHelper';
import store from 'dashboard/store';
import {
  buildTeamLocationRouteGuard,
  canViewTeamLocationMap,
} from 'dashboard/helper/kaptionTeamLocationAvailability';

const KaptionTeamLocationPage = () => import('./KaptionTeamLocationPage.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/team-location'),
    name: 'kaption_team_location_map',
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
    component: KaptionTeamLocationPage,
    // team-location.HIDDEN.4 — off (or not in the view scope) → dashboard.
    beforeEnter: buildTeamLocationRouteGuard(
      canViewTeamLocationMap,
      () => store
    ),
  },
];
